<template>
  <div>

    <v-form ref="inputForm" @submit.prevent="">
      <v-container px-10 fill-height ms-auto class="containerMaxWidth">    
        <v-stepper non-linear>
          <div class="c-stepper__header">
            <div tabindex="-1" class="c-stepper__step">
                <span class="c-stepper__step__step primary"><v-icon icon="icon" color="white">mdi-login-variant</v-icon></span>
              <div class="c-stepper__label">{{ $let('MemberNonMember_SectionTitle') }}</div>
            </div>
          </div>
        </v-stepper>
        <v-row no-gutters>
          <v-col cols="12" sm="12" md="12">
            <v-sheet color="white" class="custom-shadow pa-10">  
              <v-row no-gutters>
                <v-col cols="12" sm="12" md="12">
                  <YesNo
                    v-model="model.isMember"
                    class="subtitle-label"
                    :label="$let('MemberNonMember_AreYouAMember')"
                    :yesText="$let('ConfirmationYesLabelDefault')"
                    :noText="$let('ConfirmationNoLabelDefault')"
                    :rules="[validationRules.required]"
                    @change="model.canLogin = undefined">
                  </YesNo>
                </v-col>
              </v-row>
          
              <v-row v-if="model.isMember" no-gutters>
                <v-col cols="12" sm="12" md="12" class="mt-5">
                  <YesNo
                    v-model="model.canLogin"
                    class="subtitle-label"
                    :label="$let('MemberNonMember_CanYouLogin')"
                    :yesText="$let('ConfirmationYesLabelDefault')"
                    :noText="$let('ConfirmationNoLabelDefault')"
                    :rules="[validationRules.required]">
                  </YesNo>
                </v-col>
              </v-row>

              <StepperButtons
                @continueClick="_MemberNonMemberContinueClick"
                @backClick="_backButtonClick"
                :backAvailable="showBackButton">
              </StepperButtons>

            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </v-form>

  </div>
</template>

<script>

  import { mapActions } from "vuex";
  import StepperButtons from '../components/stepper-buttons.vue'
  import YesNo from '@/shared/components/yes-no.vue'
  import generic from '@/shared/utils/generic.js';
  import paramKeys from '../constants/param-keys.js'
  import validators from '@/shared/utils/validators.js';
  import router from '../router';
  import routerNames from '../router/router-names';

  export default {
    name: 'MemberNonMember',
    components: {
      YesNo, 
      StepperButtons
    },
    data() {
      return {
        validationRules: validators.validationRules({ reqFld: this.$let('RequiredFieldEmptyMessage') }),
        showBackButton: false,
        model: {
          isMember: undefined,
          canLogin: undefined,
        }, 
      };
    },
    mounted() {
      if (!this.$store.state.loanEnquiryData.eligible) router.push({ name: routerNames.Home })
      this.model.isMember = this.$store.state.loanEnquiryData.isMember;
      this.model.canLogin = this.$store.state.loanEnquiryData.canLogin;
      this.showBackButton = generic.paramValue(this.$store, paramKeys.EligibilityCheckEnabled).toBool();
    },
    methods: {
      ...mapActions(["updateLocalLoanEnquiryData"]),

      _backButtonClick() { 
        router.push({ name: routerNames.Home });
      },

      _MemberNonMemberContinueClick() {
        if (this.$refs.inputForm.validate()) {
          this.updateLocalLoanEnquiryData(this.model);

          const redirectUnregisteredUserUrl = generic.paramValue(this.$store, paramKeys.RedirectUnregisteredUserUrl);

          if (this.model.isMember && this.model.canLogin) {
            generic.openWindow(generic.paramValue(this.$store, paramKeys.RedirectToLoginPage));
          }
          else if (this.model.isMember && !this.model.canLogin && redirectUnregisteredUserUrl) {
            generic.openWindow(redirectUnregisteredUserUrl);
          }
          else router.push({ name: routerNames.ConfirmMembership });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>

</style>